import Tag from '@doordash/component-tag'
import { TagProps } from '@doordash/component-tag/src/types/TagTypes'
import { Colors, StackChildren, Text } from '@doordash/design-language'
import * as React from 'react'
import { i18nKeys } from 'translationTypes'
import {
  CheckrStatusResults,
  ConfirmationStepKeys,
  ConfirmationStepTrackingKeys,
} from '../../../constants'
import i18n from '../../../i18n'

const MIN_NCC_BACKGROUND_CHECK_PROCESSING_HOURS = 24
const MAX_NCC_BACKGROUND_CHECK_PROCESSING_HOURS = 48

interface NCCBackgroundCheckDetailsProps {
  tagType?: TagProps['type']
  label: string
  description: string
}

interface NCCBackgroundCheckProps {
  backgroundCheckResults?: CheckrStatusResults
  /**
   * transient props - not used within this component
   * Needed for use within dropshipping-status
   */

  alwaysEnabled?: boolean
  generateTitle?: (isComplete: boolean) => string
  step?: ConfirmationStepTrackingKeys
  completeKey?: ConfirmationStepKeys
}

const NCCBackgroundCheckDetails: React.FC<NCCBackgroundCheckDetailsProps> = ({
  tagType,
  label,
  description,
}) => {
  return (
    <StackChildren size={StackChildren.Sizes.XxSmall}>
      <Tag size={Tag.Sizes.Medium} text={label} type={tagType} />
      <Text styles={Text.Styles.SectionSubtext} color={Colors.SystemGrey80}>
        {description}
      </Text>
    </StackChildren>
  )
}

const NCCBackgroundCheckStep: React.FC<NCCBackgroundCheckProps> = ({
  backgroundCheckResults,
}) => {
  if (backgroundCheckResults === CheckrStatusResults.Clear) {
    return (
      <NCCBackgroundCheckDetails
        tagType={Tag.Types.HighlightDefault}
        label={i18n.t(i18nKeys.backgroundCheckStatus__complete__label)}
        description={i18n.t(
          i18nKeys.backgroundCheckStatus__complete__description
        )}
      />
    )
  }

  if (backgroundCheckResults === CheckrStatusResults.Suspended) {
    return (
      <NCCBackgroundCheckDetails
        tagType={Tag.Types.WarningEmphasis}
        label={i18n.t(i18nKeys.backgroundCheckStatus__needsAction__label)}
        description={i18n.t(
          i18nKeys.dropshippingStatus__backgroundNccNeedsAttentionDescription
        )}
      />
    )
  }

  return (
    <NCCBackgroundCheckDetails
      label={i18n.t(i18nKeys.backgroundCheckStatus__inProgress__label)}
      description={i18n.t(
        i18nKeys.dropshippingStatus__backgroundNccInProgressDescription,
        {
          minHours: MIN_NCC_BACKGROUND_CHECK_PROCESSING_HOURS,
          maxHours: MAX_NCC_BACKGROUND_CHECK_PROCESSING_HOURS,
        }
      )}
    />
  )
}

export default NCCBackgroundCheckStep
